<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            护士列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row style="float: left;">
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click="handleEdit">编辑</el-button>
                    <el-button type="danger" :disabled="disabledBind" @click="handleRelation">绑定账号</el-button>
                    <el-button type="info" :disabled="disabledDetail" @click="handleInfo">绑定详情</el-button>
                </el-row>
                <div style="float:right">
                    <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 5px;width:200px"></el-input>
                    <el-select
                        v-model="status"
                        style="margin:0 5px;width:200px"
                        placeholder="请选择用户用户类型">
                        <el-option
                            v-for="item in statusValue"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                </div>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column
                                prop="gender"
                                :formatter="genderTitle"
                                label="性别">
                        </el-table-column>
                        <el-table-column prop="birthday" label="生日"></el-table-column>
                        <el-table-column prop="phone" label="手机号"></el-table-column>
                        <el-table-column prop="departmentName" label="部门"></el-table-column>
                        <el-table-column
                                prop="status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:departmentList="departmentList" v-on:close="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:departmentList="departmentList" v-on:close="closeEdit" v-on:getList="getList"></Edit>
        <Relation ref="myRelation" v-show="showModalRelation" v-on:closeRelation="closeRelation" v-on:getList="getList"></Relation>
        <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo" v-on:getList="getList"></Info>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Add from "./Add";
    import Edit from "./Edit";
    import Relation from "./Relation";
    import Info from "./Info";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                showModalAdd:false,
                showModalEdit:false,
                showModalRelation:false,
                showModalInfo:false,
                tableData:null,
                row:null,
                menuButtonList:null,
                disabledAdd:true,
                disabledEdit:true,
                disabledBind:true,
                disabledDetail:true,
                departmentList:[],
                areaValue:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                phone:'',
                name:'',
                status:0,
                departmentCode:'',
                statusValue:[{value:-1,label:"全部状态"},{value:0,label:"正常"},{value:1,label:"禁用"}]
            }
        },
        components:{
            Add,Edit,Relation,Info
        },
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            rowClick(row){
                this.row=row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
                if(this.menuButtonList.indexOf("绑定账号")!=-1){
                    this.disabledBind =false;
                }
                if(this.menuButtonList.indexOf("绑定详情")!=-1){
                    this.disabledDetail =false;
                }
                
            },
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Department/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.departmentList=response.data.data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            handleEdit() {
                this.closeEdit();
                this.$refs.myEdit.init(this.row);
            },
            handleInfo() {
                this.closeInfo();
                this.$refs.myInfo.init(this.row);
            },
            handleRelation() {
                this.closeRelation();
                this.$refs.myRelation.init(this.row);
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd(){
                this.closeAdd();
                this.$refs.myAdd.init();
            },
            closeAdd(){
                this.showModalAdd = !this.showModalAdd;
            },
            closeEdit(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeInfo(){
                this.showModalInfo = !this.showModalInfo;
            },
            closeRelation(){
                this.showModalRelation = !this.showModalRelation;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Nurse/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit = true;
                    this.disabledBind = true;
                    this.disabledDetail = true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            genderTitle(row){
                if(row.gender == 0){
                    return "女";
                }
                if(row.gender == 1){
                    return "男";
                }
                return "其它";
            },
        }
    }
</script>
<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
</style>
